import { AppService } from './app.service';
import { environment } from '../environments/environment';
var AppComponent = /** @class */ (function () {
    function AppComponent(_service) {
        this._service = _service;
        this.loadRecaptchaScript();
    }
    /**
     * Carica dinamicamente lo script reCAPTCHA usando la chiave dalle environment variables
     */
    AppComponent.prototype.loadRecaptchaScript = function () {
        var script = document.createElement('script');
        script.src = "https://www.google.com/recaptcha/enterprise.js?render=" + environment.captcha_key;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    };
    AppComponent.prototype.logout = function () {
        this._service.logout();
    };
    return AppComponent;
}());
export { AppComponent };
